import { api } from '@/core/helpers/axiosHelper';

export default {
    async get({ company_id }: { company_id: number }) {
        return await api
            .get('/cost-center', {
                params: {
                    'filter[invoiceGroup.company_id]': company_id,
                    per_page: 10000,
                },
            })
            .then((response) => response.data);
    },
};
